import React, { useEffect, useState } from "react";
import Footer from "../components/layout/Footer";
import PlacesAutocomplete from "react-places-autocomplete";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import Navbar from "../components/layout/Navbar";
import * as Api from "../api/newUser";
import useShared from "../hooks/useShared";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useLocation } from "react-router";
import {
  residentialPlanPricing,
  businessPlanPricing,
} from "../mocks/pricingMocks";

function SignUp() {
  const { state } = useLocation();
  const planType = state?.plan;
  const plans = state?.value;
  const [fields, setFields] = useState("");
  const [address, setAddress] = useState("");
  const [plan, setPlan] = useState(plans);
  const [selectedState, setSelectedState] = useState("ivory coast");
  const { getCity, cities, CityLoading } = useShared();

  console.log(plan);
  //adding the two pricing plan arrays into pone for easier mapping
  const allAvailablePlans = [].concat(
    residentialPlanPricing,
    businessPlanPricing
  );

  const handleStateChange = (event) => {
    const { name, value } = event.target;
    setFields({ ...fields, [name]: value });
    setSelectedState(event.target.value);
    const data = {
      action: "get_cities_by_states",
      state: event.target.value,
    };
    getCity(data);
  };

  const handleChangeAddress = (address) => {
    setAddress({ address });
  };
  const handleSelect = async (address) => {
    try {
      const result = await geocodeByAddress(address);
      const latLng = await getLatLng(result[0]);

      setAddress({ address, direction: latLng });
    } catch (error) {}
  };

  useEffect(() => {
    getCity({ action: "get_cities_by_states", state: selectedState });
  }, []);
  const Swal = require("sweetalert2");
  const { isLoading, mutate } = useMutation(Api.registerUser, {
    onSuccess: (data) => {
      // console.log(data);
      Swal.fire({
        title: "Réussie!",
        text: "Nous avons bien reçu vos informations. Un membre de notre équipe vous contactera très bientôt ! Merci.",
        icon: "success",
        confirmButtonColor: "#1ac9d8",
      });
      //  .then(function () {
      //   window.location.replace("");
      // });
    },
    onError: (error) => {
      return toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
      });
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields({ ...fields, [name]: value });
  
  };

  const handleSubmit = (e) => {
    e.preventDefault();
 
    mutate({
      address: address.address,
      allowEmail: true,
      phoneNumber: fields.phoneNumber,
      city: fields.city,
      country: "cv",
      email: fields.email,
      firstName: fields.firstName,
      lastName: fields.surName,
      lat: address.direction.lat,
      lng: address.direction.lng,
      phoneNumber: fields.phoneNumber,
      plan: plan,
      state: selectedState,
      aboutUs: fields.aboutus,
    });
  };

  return (
    <div className="main-container">
      <Navbar />
      <div className="signup-page col-12 col-lg-11 ml-lg-5 pricing-page ">
        <div className="col-12 col-md-5 mr-auto ml-auto mt-3">
          <h3 className="text-center">S'inscrire</h3>
          <p>
            Remplissez le court formulaire avec vos coordonnées et passez à
            l'étape suivante.
          </p>
          <form onSubmit={handleSubmit} className="form-horizontal">
            <div className="form-group">
              <div className="d-flex">
                <div className="mb-3 mr-auto col pl-0">
                  <label>Prénom</label>
                  <input
                    type="text"
                    name="firstName"
                    className="form-control"
                    placeholder="Prénom"
                    required
                    onChange={handleChange}
                    v-model="firstName"
                  />
                </div>

                <div className="mb-3 col pr-0">
                  <label>Nom de famille</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nom de famille"
                    required
                    name="surName"
                    onChange={handleChange}
                    v-model="surName"
                  />
                </div>
              </div>
              <div className="mb-3">
                <label>Numéro de téléphone</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Numéro de téléphone"
                  required
                  onChange={handleChange}
                  name="phoneNumber"
                  v-model="phoneNumber"
                />
              </div>

              <div className="mb-3">
                <label>Adresse e-mails</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Adresse e-mails"
                  required
                  onChange={handleChange}
                  v-model="emailAddress"
                />
              </div>
              <div className="mb-3">
                <label>Régions</label>
                <select
                  className="form-control"
                  name="region"
                  onChange={handleStateChange}
                  value={selectedState}
                  required
                >
                  <option value="">
                    Sélectionnez votre région de résidence
                  </option>
                  <option value="ivory coast">Ivory Coast</option>
                </select>
              </div>

              {selectedState && (
                <div className="mb-3">
                  <label>Ville</label>
                  <select
                    className="form-control"
                    v-model="city"
                    name="city"
                    onChange={handleChange}
                    required
                  >
                    <option value="">Sélectionnez votre ville</option>
                    {CityLoading ? (
                      <option value="">Chargement des villes...</option>
                    ) : (
                      cities.map((city) => (
                        <option value={city.city}>{city.city}</option>
                      ))
                    )}
                  </select>
                </div>
              )}

              <div className="mb-3">
                <label>Adresse physique</label>
                <PlacesAutocomplete
                  name="address"
                  value={address.address}
                  onChange={handleChangeAddress}
                  onSelect={handleSelect}
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                  }) => (
                    <div>
                      <input
                        {...getInputProps({
                          label: "Adresse physique",
                          placeholder: "Lieux de recherche...",
                          className: "form-control",
                          name: "address",
                          required: true,
                        })}
                      />
                      <div className="autocomplete-dropdown-container">
                        {loading && <div>Chargement des adresses...</div>}
                        {suggestions.map((suggestion) => {
                          const className = suggestion.active
                            ? "suggestion-item--active"
                            : "suggestion-item";
                          // inline style for demonstration purpose
                          const style = suggestion.active
                            ? { backgroundColor: "#fafafa", cursor: "pointer" }
                            : { backgroundColor: "#ffffff", cursor: "pointer" };
                          return (
                            <div
                              {...getSuggestionItemProps(suggestion, {
                                className,
                                style,
                              })}
                            >
                              <span>{suggestion.description}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </PlacesAutocomplete>
              </div>

              <div className="mb-3">
                <label>Sélectionnez le plan</label>
                {/* mapping the pricing mockup arrays   */}
                {allAvailablePlans.map((data, index) => (
                  <div key={index} className="custom-control custom-radio">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id={data.id}
                      name="plan"
                      value={plan}
                      onChange={(e) => setPlan(e.target.value)}
                      v-model="plan"
                      defaultChecked={planType === data.plan}
                    />
                    <label className="custom-control-label" for={data.id}>
                      {data.plan} @ FCFA {data.price} / {data.month}{" "}
                    </label>
                  </div>
                ))}
              </div>
              <div className="mb-3">
                <label>Comment avez-vous entendu parler de nous?</label>
                <select
                  className="form-control"
                  v-model="source"
                  required
                  name="aboutus"
                  onChange={handleChange}
                >
                  <option>Ami</option>
                  <option>Facebook</option>
                  <option>Twitter</option>
                  <option>Recherche Google</option>
                  <option>Instagram</option>
                  <option>Radio</option>
                  <option>Panneau d'affichage</option>
                  <option>Journal</option>
                  <option>Publicité télévisée</option>
                  <option>Prospectus</option>
                  <option>Autocollants</option>
                </select>
              </div>

              {/* <div className="mb-3">
                <label>Sélectionnez l'option de paiement préférée :</label>
                <select
                  className="form-control"
                  v-model="paymentOption"
                  required
                >
                  <option>Flutterwave</option>
                </select>
              </div> */}
              <div className="mb-3">
                {isLoading ? (
                  <>
                    <input
                      className="btn signup-btn w-100 text-white"
                      role="button"
                      disabled
                      value="Soumission..."
                    />
                  </>
                ) : (
                  <input
                    className="btn signup-btn w-100 text-white"
                    role="button"
                    value="Procéder"
                    type="submit"
                  />
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SignUp;

//mock selection plan: just incase any data point from plan selection was missed if not delete
{
  /* <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="residentialunlimited"
                    name="groupOfDefaultRadios"
                    value="Residential Unlimited"
                    v-model="plan"
                    defaultChecked={planType === "RÉSIDENTIEL ILLIMITÉ"}
                  />
                  <label
                    className="custom-control-label"
                    for="residentialunlimited"
                  >
                    Résidentiel Illimité @ FCFA 150 / Mois{" "}
                  </label>
                </div>

                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="residentialpro"
                    name="groupOfDefaultRadios"
                    v-model="plan"
                    value="Residential Pro"
                    defaultChecked={planType === "PRO RÉSIDENTIEL"}
                  />
                  <label className="custom-control-label" for="residentialpro">
                    Résidentiel Pro @ FCFA 900 / 6mois (Premier mois GRATUIT)
                  </label>
                </div>

                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="residentialyearly"
                    name="groupOfDefaultRadios"
                    v-model="plan"
                    value="Residential Yearly"
                    defaultChecked={planType === "RÉSIDENTIEL À L'ANNÉE"}
                  />
                  <label
                    className="custom-control-label"
                    for="residentialyearly"
                  >
                    Résidentiel Annuel @ FCFA 1800 / 12 mois (2 premiers mois
                    GRATUITS)
                  </label>
                </div>
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="businessunlimited"
                    name="groupOfDefaultRadios"
                    v-model="plan"
                    value="Business Unlimited"
                  />
                  <label
                    className="custom-control-label"
                    for="businessunlimited"
                  >
                    Business Unlimited @ FCFA 200 (1-10 utilisateurs)
                  </label>
                </div>
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="businesspro"
                    name="groupOfDefaultRadios"
                    v-model="plan"
                    value="Business Pro"
                  />
                  <label className="custom-control-label" for="businesspro">
                    Business Pro @ FCFA 250 (11-20 utilisateurs)
                  </label>
                </div> */
}
